import { Button, Row, Table, Tag, Tooltip } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { computed, useComputed } from '@preact/signals-react'
import { FaPlus } from 'react-icons/fa6'

import SubsectionTableActions from './actions'
import { formStateActions } from '@/state/actions'
import SubsectionTableFormDrawer from './form'
import { ApplicationsState, FormState } from '@/state'
import {
  EApplicationStatus,
  EFormFieldTypes,
  EFormTableMode,
  TApplication,
} from '@/interfaces'

import './styles.scss'

function renderTableValue(value: any, fieldType: EFormFieldTypes) {
  if (
    [EFormFieldTypes.BOOLEAN_SWITCH, EFormFieldTypes.BOOLEAN].includes(
      fieldType
    )
  ) {
    return value ? <Tag color='green'>SI</Tag> : <Tag color='red'>NO</Tag>
  }

  return value
}

export const canChangeTableData = computed(() => {
  const entityName = FormState.currentEntity?.value?.name
  const applicationStatus =
    ApplicationsState.currentApplication.value?.estadoName

  const isObservation = entityName === 'CObservacion'
  const isValidApplicationStatus = Boolean(
    applicationStatus &&
      [
        EApplicationStatus.OFFLINE,
        EApplicationStatus.WITHOUT_START,
        EApplicationStatus.IN_PROCESS,
        EApplicationStatus.COMPLETED,
        EApplicationStatus.CHANGES_REQUIRED,
      ].includes(applicationStatus as EApplicationStatus)
  )

  return Boolean(
    entityName &&
      (isObservation ||
        (ApplicationsState.viewMode.value.edit && isValidApplicationStatus))
  )
})

export default function SubsectionTable() {
  const handleCreateRowData = () => {
    formStateActions.openSubsectionForm(EFormTableMode.CREATE)
  }

  const canCreate = useComputed(() =>
    Boolean(
      FormState.currentEntity.value?.permission?.create &&
        canChangeTableData.value
    )
  )

  const entityColumns = useComputed<ColumnsType<TApplication>>(
    () =>
      (FormState.currentEntity.value?.sections ?? [])[0].fields
        ?.slice(0, 7)
        .map((field) => ({
          align: 'center',
          dataIndex: field.name,
          title: field.label,
          render: (value) => renderTableValue(value, field.type),
        })) ?? []
  )

  if (FormState.entityForm.value.openDrawer)
    return <SubsectionTableFormDrawer />

  return (
    <Row className='subsection-table-content'>
      {canCreate.value && (
        <Tooltip placement='left' title='Agregar registro'>
          <Button
            size='large'
            className='add-icon-btn'
            shape='circle'
            icon={<FaPlus size={18} />}
            onClick={handleCreateRowData}
          />
        </Tooltip>
      )}
      <Table
        className='subsection-table'
        pagination={false}
        rowKey='id'
        columns={[
          ...entityColumns.value,
          {
            align: 'center',
            fixed: 'right',
            title: 'Acciones',
            render: (rowData: TApplication) => (
              <SubsectionTableActions rowInfo={rowData} />
            ),
          },
        ]}
        dataSource={ApplicationsState.currentEntityTableData.value}
      />
    </Row>
  )
}
